import { mapGetters, mapActions } from 'vuex'
import LocalStorageService from '@/services/local-storage.service'
export default {
	methods: {
		...mapActions('settings', ['sendDwhAction']),
		timeClick() {
			const timestamp = Math.floor(Date.now() / 1000)
			return timestamp
		},
        async sendTrigger({ category, action, module, title, data, content_chapter_id, time }) {
            try {
                const creds = this.dwhCredentials
                if (!creds) return

                const triggerPayload = {
                    session_id: this.sessionId,
                    platform: 'web app',
                    login: this.login,
                    category,
                    action,
                    module,
                    time: this.timeClick(),
                }

                if (this.version) triggerPayload.version = this.version
                if (content_chapter_id?.length) triggerPayload.chapter_id = content_chapter_id
                else if (this.chapter_id) triggerPayload.chapter_id = this.chapter_id
                if (this.user_id) triggerPayload.user_id = this.user_id
                if (title) triggerPayload.title = title
                if (data) triggerPayload.data = data
                this.sendDwhAction({ credentials: creds, payload: triggerPayload })
                    .catch(() => {})
            } catch (e) {
                console.warn('[DWH] sendTrigger suppressed error:', e)
            }
        },
	},
	computed: {
		...mapGetters('auth', ['profile']),
		...mapGetters('app', ['sessionId']),
        dwhCredentials() {
            try {
                const raw = LocalStorageService.get('settings')
                if (!raw) return null
                const parsed = JSON.parse(raw)
                return parsed?.dwh?.value ?? null
            } catch (e) {
                console.warn('[DWH] bad settings in localStorage, ignore:', e)
                return null
            }
        },
		user_id() {
			return this.profile ? this.profile.user_id : null
		},
		chapter_id() {
			return this.profile ? this.profile.chapters.map((chapter) => chapter.chapter_id) : null
		},
		version() {
			return process.env.VUE_APP_VERSION
		},
		login() {
			return LocalStorageService.get('email')
		},
	},
}
